module.exports = __webpack_public_path__ + "static/media/buffet9.d4bf58ac.jpg";